import { debugTl } from '@order/utils/getDebugLog'
import type { i18n } from 'i18next'

export const tlFallback = (i18n: i18n, key: string, fallback: string) => {
  if (i18n.exists(key)) {
    return i18n.t(key)
  }
  debugTl.warn({ key, fallback }, 'using fallback for i18n key')
  return i18n.t(fallback)
}

export const getKeyFallback = (i18n: i18n, key: string, fallback: string) => {
  if (i18n.exists(key)) {
    return key
  }
  debugTl.warn({ key, fallback }, 'using fallback for i18n key')
  return fallback
}

type PathKey = string | undefined

export const getFirstExistingKey = (i18n: i18n, keys: PathKey[]) => {
  for (const key of keys) {
    if (!key) {
      continue
    }
    if (i18n.exists(key)) {
      debugTl.warn({ key, keys }, 'selected key from i18n keys')
      return key
    }
  }

  return undefined
}

export const getFirstValidTl = (
  i18n: i18n,
  keys: [string, string, ...string[]]
) => {
  const key = getFirstExistingKey(i18n, keys)
  if (key) {
    return i18n.t(key)
  }
  return i18n.t(keys[keys.length - 1])
}

export const joinPaths = (paths: (string | undefined | null)[]) => {
  if (paths.some((p) => !p)) {
    return undefined
  }
  return paths.join('.')
}
